import { RequestDocumentInput, UserService } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export type Variables = {
  input: {
    uid: string;
    requestBody?: Array<RequestDocumentInput>;
  };
};

export const usePublicUploadDocumentsMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof UserService.postUsersRequestDocuments1>>,
      QueryError,
      Variables,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ input: { uid, requestBody } }: Variables) => UserService.postUsersRequestDocuments1(uid, requestBody),
    {
      ...options,
      onSuccess: () => {
        toast.success('Successfully uploaded');
      },
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
